import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Container, Navbar, File, Nav, NavDropdown, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import BusinessIcon from '@material-ui/icons/Business';
import PeopleIcon from '@material-ui/icons/People';
import BookIcon from '@material-ui/icons/Book';
import FolderIcon from '@material-ui/icons/Folder';
import ImageIcon from '@mui/icons-material/Image';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import GamepadIcon from '@mui/icons-material/Gamepad';
import StarIcon from '@material-ui/icons/Star';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import OrganizationFragment from '../fragments/OrganizationFragment';
import EmployeeFragment from '../fragments/EmployeeFragment';
import CourseFragment from '../fragments/CourseFragment';
import MaterialFragment from '../fragments/MaterialFragment';
import QuizzesFragment from '../fragments/QuizzesFragment';
import ReportFragment from '../fragments/ReportFragment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import InfographicsIcon from '@material-ui/icons/PhotoLibrary';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MastersFragment from '../fragments/MastersFragment';
import UserRatingScreen from './UserRatingScreen';
import RatingFragment from '../fragments/RatingFragment';
import InfographicsFragment from '../fragments/InfographicsFragment';
import NotificationsFragment from '../fragments/NotificationsFragment';
import UserFragment from '../fragments/UserFragment';
import PollIcon from '@mui/icons-material/Poll';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import SurveyFragment from '../fragments/SurveyFragment';
import AnswerFragment from '../fragments/AnswerFragment';
import GeneralQuizFragment from '../fragments/GeneralQuizFragment';
import ThumbnailFragment from '../fragments/ThumbnailFragment';
import GeneralQuizMasterFragment from '../fragments/GeneralQuizMasterFragment';
import SurveyMasterFragment from '../fragments/SurveyMasterFragment';
import ModuleFragment from '../fragments/ModuleFragment';
import FolderFragment from '../fragments/FolderFragment';


const HomeScreen = () => {

    const [currentScreen, setCurrentScreen] = useState(7);
    const [employees, setEmployees] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [materials, setMaterials] = useState([]);
    const [courses, setCourses] = useState([]);
    const [companies, setCompanies] = useState([]);
    const permissions = localStorage.getItem('permission');

    const handleMenuItemClick = (screenIndex) => {
        setCompanies('');
        setCourses('');
        setMaterials('');
        setCurrentScreen(screenIndex);
    };


    useEffect(() => {
        // fetchCompanies();
        if (localStorage.getItem('type') == 'admin' || localStorage.getItem('type') == 'owner') {
            localStorage.clear();
            window.location.reload();
        }
        fetchEmployees();
    }, []);

    // const fetchCompanies = async () => {
    //     const myHeaders = new Headers();
    //     myHeaders.append("Authorization", localStorage.getItem('token'));
    //     const requestOptions = {
    //         method: "GET",
    //         headers: myHeaders,
    //         redirect: "follow"
    //     };
    //     fetch("https://beiguru.co.in/admin/companies", requestOptions)
    //         .then((response) => {
    //             if (response.status == 401) {
    //                 localStorage.clear();
    //                 window.location.reload();
    //                 return [];
    //             } else {
    //                 return response.json()
    //             }
    //         })
    //         .then((result) => setCompanies(result))
    //         .catch((error) => console.error(error));
    // }

    const fetchEmployees = async () => {
        console.log('HERE');
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch("https://beiguru.co.in/admin/employees", requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => setEmployees(result))
            .catch((error) => console.error(error));
    }


    return (
        <div style={{ height: '100vh' }}>
            <Navbar bg="white" expand="lg" elevation={5} style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
                <Navbar.Brand href="#home" style={{ marginLeft: '20px' }}>
                    <img
                        src={require("../assets/coloredLogo.png")}
                        height="30"
                        className="d-inline-block align-center"
                        alt="Logo"
                    />
                </Navbar.Brand>
            </Navbar>
            <Grid container spacing={0} justifyContent="center" alignItems="center" style={{ height: '92%', fontFamily: "Noto Sans", }}>
                <Grid item xs={2} style={{ fontFamily: "Noto Sans", fontWeight: '500', backgroundColor: '#F6F6F6', height: '100%', justifyContent: 'start', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ height: '10px', }} />
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('dashboard') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 7 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(7);
                    }}>
                        <DashboardIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Dashboard</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('company') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 0 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(0);
                    }}>
                        <BusinessIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Organization Master</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('employee') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 1 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(1);
                    }}>
                        <PeopleIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Students Master</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('material') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 2 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(2);
                    }}>
                        <LibraryBooksIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Materials Master</p>
                    </div> : null}
                    {/* {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('course') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 3 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(3);
                    }}>
                        <ImageIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Thumbnail Master</p>
                    </div> : null} */}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('course') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 4 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(4);
                    }}>
                        <ImageIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Modules Master</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('course') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 3 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(3);
                    }}>
                        <BookIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Course Master</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('employee') || localStorage.getItem('permission').includes('course') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 25 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(25);
                    }}>
                        <FolderIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Folder Structure</p>
                    </div> : null}
                    {/* {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('quiz') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 4 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(4);
                    }}>
                        <QuestionAnswerIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Quizzes</p>
                    </div> : null} */}

                    {/* {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('answers') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 13 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(13);
                    }}>
                        <ContactSupportIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Answer Master</p>
                    </div> : null} */}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('rating') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 5 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(5);
                    }}>
                        <StarIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Rating Master</p>
                    </div> : null}
                    {/* {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('generalquiz') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 11 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(11);
                    }}>
                        <GamepadIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>General Quiz Master</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('generalquiz') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 14 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(14);
                    }}>
                        <GamepadIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>General Quiz</p>
                    </div> : null} */}
                    {/* {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('survey') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 12 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(12);
                    }}>
                        <PollIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Survey Master</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('survey') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 15 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(15);
                    }}>
                        <PollIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Survey</p>
                    </div> : null} */}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('info') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 9 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(9);
                    }}>
                        <InfographicsIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Info Master</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('notification') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen === 10 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(10);
                    }}>
                        <NotificationsIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Notification Master</p>
                    </div> : null}
                    {localStorage.getItem('type') == 'superadmin' ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 6 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(6);
                    }}>
                        <SettingsIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>User Management</p>
                    </div> : null}
                    {localStorage.getItem('permission').includes('all') || localStorage.getItem('permission').includes('master') ? <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center', color: currentScreen == 8 ? 'blue' : 'grey' }} onClick={() => {
                        setCompanies('');
                        setCourses('');
                        setMaterials('');
                        setCurrentScreen(8);
                    }}>
                        <ViewModuleIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Data Master</p>
                    </div> : null}
                    <div style={{ flex: 1, }} />
                    <div style={{ cursor: 'pointer', height: '45px', verticalAlign: 'middle', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', alignContent: 'center' }} onClick={() => {
                        localStorage.clear();
                        window.location.reload();
                    }}>
                        <ExitToAppIcon style={{ marginLeft: '20px', marginRight: '10px' }} />
                        <p style={{ margin: '0px' }}>Logout</p>
                    </div>
                    <div style={{ height: '10px', }} />
                    {/* <p style={{ fontSize: '12px', fontWeight: '600', fontFamily: 'Noto Sans' }}>Uplifting Security Culture</p> */}
                    <p style={{ fontSize: '12px', fontWeight: '600', fontFamily: 'Noto Sans' }}> Excellence and Service </p>
                </Grid>
                {currentScreen == 0 ? <OrganizationFragment /> : null}
                {currentScreen == 1 ? <EmployeeFragment company={companies} department={courses} /> : null}
                {currentScreen == 2 ? <MaterialFragment onMaterialClick={(company, course, material) => {
                    setCompanies(company);
                    setCourses(course);
                    setMaterials(material);
                    setCurrentScreen(4);
                }} company={companies} course={courses} /> : null}
                {currentScreen == 3 ? <CourseFragment company={companies} department={courses} /> : null}
                {currentScreen == 4 ? <ModuleFragment onCourseClick={(company, course) => {
                    console.log(company);
                    console.log(course);
                    setCompanies(company);
                    setCourses(course);
                    setCurrentScreen(3);
                }} /> : null}
                {/* {currentScreen == 5 ? <QuizzesFragment company={companies} course={courses} material={materials} /> : null} */}
                {currentScreen == 5 ? <RatingFragment /> : null}
                {currentScreen == 6 ? <UserFragment /> : null}
                {currentScreen == 7 ? <ReportFragment /> : null}
                {currentScreen == 8 ? <MastersFragment /> : null}
                {currentScreen == 9 ? <InfographicsFragment /> : null}
                {currentScreen == 10 ? <NotificationsFragment /> : null}
                {currentScreen == 11 ? <GeneralQuizMasterFragment /> : null}
                {currentScreen == 14 ? <GeneralQuizFragment /> : null}
                {currentScreen == 12 ? <SurveyMasterFragment /> : null}
                {currentScreen == 15 ? <SurveyFragment /> : null}
                {currentScreen == 13 ? <AnswerFragment /> : null}
                {currentScreen == 25 ? <FolderFragment onCoursesClick={(company, department) => {
                    setCompanies(company);
                    setCourses(department);
                    setCurrentScreen(3);
                }} onStudentsClick={(company, department) => {
                    setCompanies(company);
                    setCourses(department);
                    setCurrentScreen(1);
                }} /> : null}
            </Grid>
        </div>
    );
};

export default HomeScreen;
